var React = require('react');

function LeftSmall (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"11","stroke":"#423D33","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M26.2933 28.5896L25.59 29.2929L20.2971 24L25.5887 18.7084L26.2941 19.4188L22.0664 23.6464L21.7133 23.9996L22.0661 24.3532L26.2933 28.5896Z","fill":"#423D33","stroke":"#423D33","key":1})]);
}

LeftSmall.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = LeftSmall;

LeftSmall.default = LeftSmall;
